<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="ded-title"><b>ACKNOWLEDGMENTS</b></p>
<p class="indent">There are many people to thank for their contributions to this book.</p>
<p class="indent">Thanks to Roxane Cerda, the C&amp;T acquisitions editor who believed in my first book, <i>Modern Fabric Art Bowls</i>, and gave me the opportunity to write this second book to follow up with patterns and directions for round bowls.</p>
<p class="indent">Many thanks to my editor, Madison Moore, whose incredible patience and technical assistance have helped me from the very beginning of this book.</p>
<p class="indent">Another thank you to the many other people at C&amp;T who worked with us on making this book.</p>
<p class="indent">Many thanks to my good friend Martha McDonald. Her support, calm steadiness, and clear thinking made writing this book so much easier.</p>
<p class="indent">And thanks to Madeleine Appell for letting me use some of her fabric.</p>
<p class="indent">I was lucky to come across Tres Rebecas, a craft shop in San Antonio, Texas with an incredible staff and a treasure chest of some of my favorite sold-out fabrics, some of which have been used in this book.</p>
<p class="indent">Since my first book, <i>Modern Fabric Art Bowls</i>, was published, many crafters from many parts of the world have become my social media friends, and I thank you for all the great pictures of your fabric bowls and the encouragement to take on this book.</p>
<p class="indent">My husband, Ken Fisher, isn’t a crafter, but no one has encouraged me more.</p>
<p class="fig"><img alt="" src="images/pg3_1.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_ack.vue?6f8b19b2